import { render, staticRenderFns } from "./PersistRastreamentoHistoricoView.vue?vue&type=template&id=22187cc5&"
import script from "./PersistRastreamentoHistoricoView.vue?vue&type=script&lang=ts&"
export * from "./PersistRastreamentoHistoricoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports